export default __webpack_public_path__ + "static/media/copy_icon.c5c92684.webp";